import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const InfoItem = ({ label, value }) => (
  <Box
    display={'flex'}
    sx={{
      justifyContent: 'space-between',
      alignItems: { xs: 'flex-start', sm: 'center' },
      flexDirection: { xs: 'column', sm: 'row' },
    }}
  >
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={500}>
      {value || '-'}
    </Typography>
  </Box>
);

export default InfoItem;
